// Vendor Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {isArray} from 'lodash';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import MoviesAndProgramsCredits from '../app/movies-and-programs-credits';
import MoviesAndProgramsThumbnails from '../app/movies-and-programs-thumbnails';
import SearchRecordDetails from '../app/search-record-details';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './movies-and-programs-detail.scss';

const servicesDataKey = 'moviesAndProgramsDetail';

function MoviesAndProgramsDetail(props) {
    const {error, fetched, fetching, routerParams, searchData} = props;

    const getSearchRecordDetails = () => ({
        ...props,
        servicesDataKey,
        keyOrder: 'moviesAndPrograms',
        keyRenderers: {
            credits: renderCredits,
        },
    });

    const renderCredits = (searchValues, _key) =>
        (isArray(searchValues) ? <MoviesAndProgramsCredits searchValues={searchValues} /> : `${searchValues}`);

    const renderNoRecordFound = () => {
        const {echostarId, roviProgramId} = routerParams;
        const echostarMessage = echostarId ? `Echostar Id: ${echostarId}` : null;
        const roviMessage = !echostarId && roviProgramId ? `Rovi Program Id: ${roviProgramId}` : null;

        return fetched && !searchData.length && (echostarId || roviProgramId) ? (
            <div className="movies-and-programs-detail--message">
                No records found for {echostarMessage}
                {roviMessage}
            </div>
        ) : null;
    };

    return (
        <div className="movies-and-programs-detail">
            <Loading loading={fetching} />
            <Error error={error} />
            <MoviesAndProgramsThumbnails searchData={searchData} />
            <SearchRecordDetails {...getSearchRecordDetails()} />
            {renderNoRecordFound()}
        </div>
    );
}

MoviesAndProgramsDetail.propTypes = {
    error: PropTypes.bool,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array,
};

export default withSearch(MoviesAndProgramsDetail, servicesDataKey);
